"use client";

import { useEffect, useState } from "react";

/**
 * The hash the address bar shows, without the "#", kept current across
 * in-page jumps. `resetKey` (the pathname, for the nav) re-reads it when the
 * page changes under a mounted component.
 */
export function useCurrentHash(resetKey) {
  const [currentHash, setCurrentHash] = useState("");
  useEffect(() => {
    const read = () => setCurrentHash(window.location.hash.slice(1));
    read();
    window.addEventListener("hashchange", read);
    window.addEventListener("popstate", read);
    return () => {
      window.removeEventListener("hashchange", read);
      window.removeEventListener("popstate", read);
    };
  }, [resetKey]);
  return [currentHash, setCurrentHash];
}
